import { gql } from '@apollo/client';

export default gql`
  query ConchRequest($input: ConchRequestInput!) {
    conchRequest(input: $input)
  }
`;
